'use strict';
import {combineReducers} from 'redux';
import {NOTIFICATIONS_LIST_NAME} from '../actions';
import {notifications} from './notifications';

export * from './state';

export const system = combineReducers({
  [NOTIFICATIONS_LIST_NAME]: notifications,
});

export const storageWhitelist = [];



// WEBPACK FOOTER //
// ./src/js/system/reducers/index.js